import { ref } from 'vue'

/**
 * 상단 바 제목을 화면이 잠깐 바꿔 쓸 때 (예: 매장 상세 → 매장 이름).
 * 라우트 meta.title 은 고정 문자열이라 "매장 상세" 밖에 못 보여 준다.
 * path 를 같이 둬서, 화면을 떠난 뒤 다음 화면에 이전 제목이 남지 않게 한다.
 */
export const pageTitleOverride = ref({ path: '', title: '' })

export function setPageTitle(path, title) {
  pageTitleOverride.value = { path, title: title || '' }
}

export function clearPageTitle(path) {
  if (pageTitleOverride.value.path === path) pageTitleOverride.value = { path: '', title: '' }
}
